import React, { useState, useEffect, useRef  } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import { Col, Form, Row } from 'react-bootstrap';



export default function SidaGetToken(props) {
    const toast = useRef(null);
    const txt = useRef(null);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [token, setToken] = useState("");
    const [loading, setLoading] = useState(false);

    
    useEffect(() => {
    }, []);

    const getToken = function(){
      setLoading(true);
      var params = {login:util.getTrustedUser()};
      var url = config.Server+`/user/school/token/get`;
      console.log("params---->", params)
      console.log("url---->", url)
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  setToken(response);
                  setLoading(false);
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setLoading(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setLoading(false);
          });

    }
    const handleCopy = async () => {
      try {
        await navigator.clipboard.writeText(token);
        alert("✅ متن با موفقیت کپی شد!");
      } catch (err) {
        console.error("خطا در کپی:", err);
        alert("❌ کپی انجام نشد!");
      }
    };
    return(      
      <>
         <div className="page-caption" style={{ width:"calc(100% - 0px)"}}>دریافت کلید سیدا</div>
         <div style={{width:"calc(100% - 0px)"}}>
            <Row>
              <Col md={6}>
                <FloatLabel>
                    <InputText  ref={txt} value={token} onChange={(e)=>{}}  keyfilter="" maxLength={200} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                    <label htmlFor="username"></label>
                </FloatLabel>
              </Col>
            </Row>
            <Row>
              <Col md={3} style={{padding:"10px"}}>
                <div className="flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
                  <Button label="دریافت کلید سیدا" icon="pi pi-plus" onClick={()=>getToken()} severity="success" iconPos="right" loading={loading} style={{width:"200px"}} />                  
                </div>
              </Col>
              <Col md={3} style={{padding:"10px"}}>
                <div className="flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
                  <Button label="کپی کلید سیدا" icon="pi pi-plus" onClick={()=>handleCopy()} severity="info" iconPos="right" loading={loading} style={{width:"200px"}} />                  
                </div>
              </Col>
            </Row>
         </div>
          <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
            <Toast ref={toast} />
      </>  
    );
  
}
